import { useNavigate } from 'react-router-dom';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import AboutMe from './AboutMe';
import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import CreateReviewForm from './CreateReviewForm';
import Highlights from './Highlights';
import ProviderEducation from './ProviderEducation';
import ProviderHeader from './ProviderHeader';
import ProviderHowITreat from './ProviderHowITreat';
import ProviderImage from './ProviderImage';
import ProviderLocations from './ProviderLocations';
import ProviderWhatITreat from './ProviderWhatITreat';
import ProviderWhoITreat from './ProviderWhoITreat';
import Review from './Review';
import BackButton from "../common/BackButton";
import useIsMobile from '../../hooks/useIsMobile';
import './ViewProvider.scss';

const ViewProvider = props => {
  const { provider, highlights, reviews, user, isPopup } = props;
  const providerHighlights = (provider.highlights || []).map(hId =>
    (highlights || []).find(h => h.id === hId)
  ).filter(h => isObject(h) && h?.category);
  const parsedProvider = {
    ...provider,
    highlights: (providerHighlights || []).filter(h => h?.category === 'HIGHLIGHT'),
    whatITreat: (providerHighlights || []).filter(h => h?.category === 'WHAT_I_TREAT'),
    whoITreat: (providerHighlights || []).filter(h => h?.category === 'WHO_I_TREAT'),
    howITreat: (providerHighlights || []).filter(h => h?.category === 'HOW_I_TREAT'),
  };
  const isProvider = get(props, 'user.is_provider') || false;
  const isMobile = useIsMobile();

  return (
    <Box className={`ViewProviderComponent${isPopup === true ? 'Popup' : ''}`}>
      {
        isPopup !== true &&
        <Box className='ViewProvider__head'>
          <Box className='ViewProvider__head__nav'>
            {
              props.user &&
              <BackButton />
            }
          </Box>
        </Box>
      }
      <Stack direction={{xs: 'column', sm: 'row'}} className='ViewProvider__body'>
        <Box className='ViewProvider__body__content'>

          <Box className='ViewProvider__section'>
            <Stack direction={{xs: 'column', lg: 'row'}}  className='ViewProvider__profile'>
              <ProviderImage provider={parsedProvider} />
              <CustomBox borderless className='ViewProvider__profile__info'>
                <ProviderHeader
                  provider={parsedProvider}
                  reviews={reviews}
                  disableRequestSession={props.disableRequestSession}
                  isProvider={props.isProvider}
                  user={user}
                  isMobile={isMobile}
                  isPopup={isPopup}
                />
              </CustomBox>
            </Stack>
          </Box>
          {!isMobile && <AboutMe provider={parsedProvider} />}
          <Highlights provider={parsedProvider} />

          {isMobile &&
            <>
              <ProviderLocations provider={parsedProvider} isMobile={isMobile}/>
              <ProviderWhatITreat provider={parsedProvider} />
              <ProviderHowITreat provider={parsedProvider} />
              <ProviderWhoITreat provider={parsedProvider} />
              <AboutMe provider={parsedProvider} />
              <AboutMe aboutMeType='funFacts' provider={parsedProvider} />
            </>
          }
          <ProviderEducation provider={parsedProvider} />
          {!isMobile && <AboutMe aboutMeType='funFacts' provider={parsedProvider} />}
          <CustomBox borderless className='ViewProvider__card'>
            <Box className='ViewProvider__reviews'>
              <CustomSubheader>Reviews</CustomSubheader>
              <Box className='ViewProvider__reviews__content'>
                {
                  props.disableAddReview || isProvider || !user
                    ? null
                    : <CreateReviewForm providerId={parsedProvider.id} />
                }
                <Box className='ViewProvider__reviews__list'>
                  {reviews && reviews.length
                    ? reviews.map((r, i) =>
                      <Box key={i} className='ViewProvider__reviews__list__item'>
                        <Review color='#EDBB60' review={r} isHideAuthorAndDate />
                      </Box>
                    )
                    : <Typography variant='paragraphSmall' color='text.light'>
                      No Reviews Yet
                    </Typography>
                  }
                </Box>
              </Box>
            </Box>
          </CustomBox>
        </Box>

        {!isMobile &&
          <Box className='ViewProvider__body__sidebar'>            
            <ProviderWhoITreat provider={parsedProvider} />
            <ProviderLocations provider={parsedProvider} />
            <ProviderWhatITreat provider={parsedProvider} />
            <ProviderHowITreat provider={parsedProvider} />
          </Box>
        }
      </Stack>
    </Box>
  );
};

ViewProvider.defaultProps = {
  disableRequestSession: false,
  disableAddReview: true,
};

ViewProvider.propTypes = {
  provider: PropTypes.object,
  user: PropTypes.object,
  disableRequestSession: PropTypes.bool,
  disableAddReview: PropTypes.bool,
};

export default ViewProvider;
